import { Link } from "react-router-dom";
import { useAuth } from "../features/auth/useAuth";

export function NotFoundPage() {
  const { isAuthenticated, dashboardPath } = useAuth();

  return (
    <main className="app-shell">
      <section className="hero fade-in">
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p className="subtitle">
          The page you requested does not exist in this frontend.
        </p>
        <div className="meta-row">
          <Link className="refresh-btn link-btn" to={isAuthenticated ? dashboardPath : "/login"}>
            {isAuthenticated ? "Go to Dashboard" : "Go to Login"}
          </Link>
        </div>
      </section>
    </main>
  );
}
